import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export interface BadgeStylesProps {
  type?: 'dot' | 'text' | 'notification';
  variant?: 'danger' | 'info' | 'warning' | 'success' | 'neutral' | 'primary';
  modifier?: 'weak' | 'regular' | 'strong' | 'inverted';
  size?: 'sm' | 'md';
  border?: 'primary' | 'success' | 'info' | 'error' | 'none';
  oval?: 'success' | 'info' | 'error';
}

export const Badge = styled.div<BadgeStylesProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.borderRadius['border-radius-1']};
  min-height: 14px;
  height: auto;
  text-transform: uppercase;
  padding: ${theme.spacing['spacing-1']} ${theme.spacing['spacing-3']};
  ${({ variant, type, modifier }) => getBadgeVariant(variant, type, modifier)}
  ${({ size }) =>
    size === 'sm' &&
    `
      padding: ${theme.spacing['spacing-1']} ${theme.spacing['spacing-2']};
      min-height: 14px;
      height: auto;
    `}
  > i {
    margin-right: ${theme.spacing['spacing-1']};
  }
  span {
    text-align: center;
    width: auto;
    white-space: nowrap;
    color: white !important;
    line-height: 1;
  }
`;

const getBadgeVariant = (variant, type, modifier) => {
  switch (type) {
    case 'dot':
      return css`
        background-color: ${theme.colors.neutral.bg.weak};
        box-shadow: inset 0 0 0 1px ${theme.colors.neutral.border.weak};
      `;
    case 'notification':
      return css`
        min-width: 24px;
        height: 16px;
        background-color: ${theme.colors['secondary-2'].bg.regular};
      `;
    default:
      return css`
        background-color: ${theme.colors[variant].bg[modifier]};
      `;
  }
};
